import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import * as fromTeamActions from '../actions/teams.actions';

import { Observable, of, filter } from 'rxjs';
import { map, catchError, withLatestFrom, switchMap, take } from 'rxjs/operators';
import { FirebaseService } from '../../services/firebase/firebase.service';
import { DocumentData, Firestore, Query, collection, query, where } from '@angular/fire/firestore';
import { User } from '../../models/user.model';
import { Team } from '../../models/team.models';

@Injectable()
export class TeamEffects {

    constructor(
        private readonly action$: Actions,
        private readonly firestore: Firestore,
        private readonly firebaseService: FirebaseService,
        private readonly store: Store<{ teamData: { data: Team[] } }>
    ) { }

    // Load Team
    loadTeam$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromTeamActions.LOAD_TEAMS),
        switchMap((value: { type: string; data: User }) => {
            const ref: Query<DocumentData, DocumentData> = query(
                collection(this.firestore, 'teams'),
                where('administrators', 'array-contains', `${value.data.id}`)
            );
            return this.firebaseService.getDataOfCollectionByField(ref).pipe(take(1));
        }),
        map((data) => ({ type: fromTeamActions.ADD_TEAM_SUCCESS, data: data })),
        catchError(error => of({ type: fromTeamActions.ADD_TEAM_FAIL, error: error }))
    ));

    // Add Team
    addTeam$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromTeamActions.AddTeamAction),
        withLatestFrom(this.store.select('teamData').pipe(filter((teamData) => !!teamData.data), take(1))),
        map(([action, teamData]) => {
            const newData = [...teamData.data];
            newData.push(action.data);
            return ({ type: fromTeamActions.ADD_TEAM_SUCCESS, data: newData })
        }),
        catchError(error => of({ type: fromTeamActions.ADD_TEAM_FAIL, error: error }))
    ));

    // Delete Team
    deleteTeam$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromTeamActions.DeleteTeamAction),
        map(() => ({ type: fromTeamActions.DELETE_TEAM_SUCCESS })),
        catchError(error => of({ type: fromTeamActions.DELETE_TEAM_FAIL, error: error }))
    ));

    // Update Team
    updateTeam$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromTeamActions.UpdateTeamAction),
        map((action) => ({ type: fromTeamActions.UPDATE_TEAM_SUCCESS, data: action.data })),
        catchError(error => of({ type: fromTeamActions.UPDATE_TEAM_FAIL, error: error }))
    ));
}